import {create} from 'zustand';
import {persist, devtools} from 'zustand/middleware';

const initialState = {
  isLoading: false,
  isSignIn: false,
  userInfo: {
    name: null,
    authLevel: null,
    tribe: {},
    church: {},
    adminCenters: [],
  },
  access: {
    label: '',
    authLevel: null,
    centerBatch: null,
    isEvangelist: false,
  },
  langOptions: [],
}

const store = persist(
  (set) => ({
    ...initialState,
    startLoading: () => set({ isLoading: true }),
    stopLoading: () => set({ isLoading: false }),
    setIsSignIn: isSignIn => set({isSignIn}),
    setUserInfo: userInfo => set({userInfo}),
    setAccess: access => set({access}),
    setLangOptions: langOptions => set({langOptions}),
  }),
  {
    name: 'zustand-store',
  }
);

export const useCommonStore = create(
  process.env.NODE_ENV !== 'production' ? devtools(store) : store
)
